import { useTranslation } from '@silospot/i18n/react';
import type { ReactElement, ReactNode } from 'react';
import { LanguageSelector } from './language-selector';

/** Centered shell (brand header + controls) shared by the auth and verify pages. */
export function AuthShell({ children }: { children: ReactNode }): ReactElement {
  const { t } = useTranslation('common');

  return (
    <div className="flex min-h-dvh flex-col bg-background">
      <header className="flex items-center justify-between p-4">
        <div className="flex items-center gap-2">
          <img src="/favicon.svg" alt="" className="h-7 w-7" />
          <span className="text-lg font-semibold">{t('appName')}</span>
        </div>
        <div className="flex items-center gap-1">
          <LanguageSelector />
        </div>
      </header>
      <main className="flex flex-1 items-center justify-center px-4 py-8">
        <div className="w-full max-w-sm">{children}</div>
      </main>
    </div>
  );
}
